import { render, staticRenderFns } from "./ArrivalCard.vue?vue&type=template&id=f95a4f48"
import script from "./ArrivalCard.vue?vue&type=script&lang=ts"
export * from "./ArrivalCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports